const Decimal = require('decimal.js');
globalThis.Decimal = Decimal;

const { FinancialSummaryMath } = require('./FinancialSummaryMath.core');

export { FinancialSummaryMath };
